import React from 'react';
import { ArrowLeft, XCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

export const ReturnsExchange = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF9F7] pt-32 pb-16">
      <div className="container mx-auto px-4">
        <Button
          variant="ghost"
          className="mb-6 text-[#2C2C2C] hover:text-[#C4B5A0]"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-seasons font-light text-[#2C2C2C] mb-8 text-center">
            Returns & Exchange Policy
          </h1>

          <Card className="bg-white border-none shadow-lg p-8 md:p-12">
            <div className="flex flex-col items-center text-center mb-8">
              <div className="bg-[#F5F3F0] p-6 rounded-full mb-6">
                <XCircle className="h-16 w-16 text-[#C4B5A0]" />
              </div>
              <h2 className="text-2xl font-seasons text-[#2C2C2C] mb-4">
                No Returns & Exchange Policy
              </h2>
            </div>

            <div className="space-y-6 text-[#2C2C2C] font-montserrat">
              <p className="leading-relaxed">
                At Sachdeva Sons, we take great pride in the quality and craftsmanship of our ethnic wear. Each piece is carefully curated and crafted with attention to detail.
              </p>

              <p className="leading-relaxed">
                <strong className="text-[#6B4E37]">Please note:</strong> We maintain a strict <strong>No Returns and No Exchange</strong> policy on all our products. This policy ensures that each garment maintains its pristine condition and quality standards.
              </p>

              <div className="bg-[#F5F3F0] p-6 rounded-lg">
                <h3 className="font-semibold text-[#6B4E37] mb-3">Why We Have This Policy:</h3>
                <ul className="space-y-2 text-sm">
                  <li className="flex items-start gap-2">
                    <span className="text-[#C4B5A0] mt-1">•</span>
                    <span>Each piece is handcrafted with intricate embroidery and embellishments</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#C4B5A0] mt-1">•</span>
                    <span>We ensure the highest quality standards for all our customers</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#C4B5A0] mt-1">•</span>
                    <span>Premium fabrics require special care and handling</span>
                  </li>
                </ul>
              </div>

              <div className="border-l-4 border-[#C4B5A0] pl-4 py-2">
                <p className="text-sm italic text-[#8B7D6B]">
                  We recommend checking the size guide and product details carefully before placing your order. If you have any questions, please contact our customer service team.
                </p>
              </div>

              <div className="pt-4">
                <h3 className="font-semibold text-[#6B4E37] mb-3">Need Help?</h3>
                <p className="text-sm">
                  If you have any concerns about your order, please contact us at:
                </p>
                <div className="mt-2 space-y-1 text-sm">
                  <p><strong>Phone:</strong> +91 9811193388</p>
                  <p><strong>Email:</strong> ssons1975@gmail.com</p>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};